import { render, staticRenderFns } from "./excellent_rates_graphicsMs.vue?vue&type=template&id=d65af9c4&scoped=true&"
import script from "./excellent_rates_graphicsMs.vue?vue&type=script&lang=js&"
export * from "./excellent_rates_graphicsMs.vue?vue&type=script&lang=js&"
import style0 from "./excellent_rates_graphicsMs.vue?vue&type=style&index=0&id=d65af9c4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65af9c4",
  null
  
)

export default component.exports